import { FormattedMessage } from 'react-intl'
import { ReactNode } from 'react'
import { ListItem, ListItemText, styled } from '@mui/material'
import { ExternalLink } from 'features/common/ui/ExternalLink'
import { MetricEventType } from 'features/metrics/api/metrics'
import { sendMetricEvent } from 'features/metrics/model/metricsMutations'
import { Avatar } from '@carto/meridian-ds/components'

const ExternalLinkStyled = styled(ExternalLink)(() => ({
  width: '100%',
  ':hover': { textDecoration: 'none' }
}))

const ListItemStyled = styled(ListItem)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  marginRight: 0,
  gap: theme.spacing(1),
  borderRadius: theme.spacing(0.5),
  padding: theme.spacing(2)
}))

const AvatarStyled = styled(Avatar)(({ theme }) => ({
  backgroundColor: theme.palette.info.light,
  color: theme.palette.common.white,
  '& svg': {
    fontSize: theme.spacing(2.25)
  }
}))

interface Props {
  icon: ReactNode
  href: string
  textId: string
  id: string
}

function FooterItem(props: Props) {
  const onClick = () => {
    sendMetricEvent(MetricEventType.HelpSidebarBlockClick, {
      resource: props.id
    })
  }

  return (
    <ExternalLinkStyled href={props.href} showIcon={false} onClick={onClick} aria-label={props.id}>
      <ListItemStyled>
        <AvatarStyled size="medium" variant="rounded">
          {props.icon}
        </AvatarStyled>
        <ListItemText>
          <FormattedMessage id={props.textId} />
        </ListItemText>
      </ListItemStyled>
    </ExternalLinkStyled>
  )
}

export default FooterItem
